import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const recursoImporterSelectors = importerSelectors(
  'recurso.importer',
);

export default recursoImporterSelectors;
